<template>
  <div class="conmon-top">
    <el-row class="search-title common-table-top" style="margin-top: 20px">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">数据列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <a v-if="butsObj.auth_third_public" @click="toBindPublic" type="primary" size="large" class="authorization-btn"
          style="float: right;margin-right: 0">授权微信第三方</a>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table class="table" v-loading="loading" :data="tableData">
        <template slot="empty">
          <div class="newTableEmpty">暂无数据，去<span @click="toBindPublic">新建</span></div>
        </template>
        <el-table-column prop="nick_name" label="昵称">
        </el-table-column>
        <el-table-column label="头像">
          <template slot-scope="scope">
            <img :src="scope.row.head_img" style="height: 100px; width: 100px;">
          </template>
        </el-table-column>
        <el-table-column prop="service_type_info" label="类型">
        </el-table-column>
        <el-table-column prop="original_id" label="原始ID">
        </el-table-column>
        <el-table-column width="135" label="授权时间">
          <template slot-scope="scope">
            {{scope.row.create_time.substring(0, 16)}}
          </template>
        </el-table-column>
        <el-table-column label="默认">
          <template slot-scope="scope">
            <div v-if="scope.row.is_default === 1" class="is-default">默认
            </div>
            <div v-if="scope.row.is_default === 0&&butsObj.set_default" class="set-default" @click="setDefaultPublicNumAction(scope.row)">
              设为默认
            </div>
          </template>
        </el-table-column>
        <el-table-column label="模型">
          <template slot-scope="scope">
            <div>{{ scope.row.name }}</div>
          </template>
        </el-table-column>
        <el-table-column width="100" label="是否启用">
          <template slot-scope="scope">
            <div v-if="scope.row.is_disable === 1&&butsObj.status_change" class="op-link" @click="startOrStopPublicAction(scope.row.id, 0)">
              <span class="pointGreen"></span>启用
            </div>
            <div class="op-link" @click="startOrStopPublicAction(scope.row.id, 1)"
              v-if="scope.row.is_default === 0 && scope.row.is_disable === 0&&butsObj.status_change">
              <span class="pointRed"></span>禁用
            </div>
            <div class="op-link" style="color: #666666" v-if="butsObj.status_change&&scope.row.is_default === 1 && scope.row.is_disable === 0">
              <span class="pointGray"></span>禁用
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>

<script>
import { publicNumber, startOrStopPublic, setDefaultPublicNum } from '@/api/customer.js'
import { getCusTypes } from '@/api/set.js'
import { API_HOST } from '../../api/local'
import { butonsList, getMenId } from '@/api/analyse.js'
export default {
  name: 'publicNumber',
  data () {
    return {
      loading: true,
      tableData: [],
      originalId: '',
      isDisabled: false,
      defaultDisabled: false,
      butsObj: { // button按钮列表
        status_change: false,
        auth_third_public: false,
        set_default: false
      }
    }
  },
  mounted () {
    this.getData()
    this.getButtonsList()
  },
  methods: {
    // 获取可用菜单按钮列表
    getButtonsList () {
      let params = {
        systemCode: 'ZY_INTELLIQUOR',
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId'),
        menuId: getMenId(this.$route.path)
      }
      butonsList(params).then(res=>{
        if (res.data.code === '200') {
          let result = res.data.result || []
          let arrObj = Object.keys(this.butsObj)
          let newarr  = result.map((item)=>{
            return item.perms
          })
          arrObj.map(it=> {
            if (newarr.indexOf(it)!==-1) {
              this.butsObj[it] = true
            } else {
              this.butsObj[it] = false
            }
          })
        }
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    startOrStopPublicAction (id, status) {
      let strMsg = ''
      if (status === 0) {
        strMsg = '是否启用该公众号'
      } else {
        strMsg = '是否禁用该公众号'
      }
      this.$confirm(strMsg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.changeWechatApi(id, status)
      }).catch((error) => {
        console.log(error)
      })
    },
    setDefaultPublicNumAction (item) {
      setDefaultPublicNum(item.id).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
        } else {
          _g.toastMsg('error', res.data.error)
        }
        this.getData()
      })
    },
    getData () {
      this.loading = true
      publicNumber().then((res) => {
        if (res.data.code === 0) {
          this.originalId = res.data.data.originalId
          for (let item of res.data.data.list) {
            if (item.original_id === this.originalId) {
              item.status = 1
            } else {
              item.status = 0
            }
          }
          this.tableData = res.data.data.list
          if (this.tableData.length === 1) {
            this.isDisabled = true
          } else {
            this.isDisabled = false
          }
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
      this.openLoading()
    },
    changeWechatApi (id, status) {
      startOrStopPublic(id, status).then((res) => {
        if (res.data.code === 0) {
          _g.toastMsg('success', '操作成功')
        } else {
          _g.toastMsg('error', res.data.error)
        }
        this.getData()
      })
    },
    // 数据加载时的动画
    openLoading () {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 跳转去绑定模型
    toBindPublic () {
      router.push('/home/bind-public-number')
    }
  },
  computed: {
    openUrl () {
      let userInfo = Lockr.get('userInfo')
      return API_HOST + 'wechat/ez_open_platform/getRequestCodeURL?uid=' + userInfo.id + '&referer=' + window.location.href
    }
  },
  created () {
  }
}
</script>

<style scoped>
.sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #e4e4e4;
  height: 60px;
  padding: 10px;
  line-height: 40px;
  margin-top: 10px;
}
.green {
  color: green;
}
.red {
  color: red;
}
.authorization-btn {
  padding: 2px 10px;
  border-radius: 2px;
  text-align: center;
  line-height: 30px;
  float: right;
  display: block;
  color: #fff;
  font-size: 14px;
  background: #1890FF;
  margin-top: 8px;
  margin-right: 13px;
  cursor: pointer;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
.set-default {
  color: #1980ff;
  cursor: pointer;
  font-size: 14px;
}
.is-default {
  font-size: 14px;
  cursor: not-allowed;
}
</style>
